import { FormControl, InputLabel, Select, OutlinedInput, Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { useEffect, useState } from 'react'
import { GridToolbar } from '../GridToolbar/GridToolbar'

const VendorCodeSelecboxGrid = ({ value, data, isLoading, dynamicId, columns, label, onChange, disabled }) => {
  const [tableData, setTableData] = useState([])
  const [isSelectorOpen, setisSelectorOpen] = useState(false)
  const [stateValue, setStateValue] = useState([])

  useEffect(() => {
    if (!isLoading) {
      setTableData(data)
    }
  }, [isLoading, data])

  const [pageSize, setPageSize] = React.useState(25)

  const handleSelectOpen = () => {
    setisSelectorOpen(true)
  }

  const handleSelectClose = () => {
    setisSelectorOpen(false)
  }

  const handleChange = (newSelectionModel) => {
    onChange(newSelectionModel)
    setisSelectorOpen(false)
  }

  useEffect(() => {
    if (value?.length > 0) {
      setStateValue(value)
    }
  }, [value])

  return (
    <>
      <FormControl fullWidth size="small">
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          value={value || []}
          label={label}
          open={isSelectorOpen}
          onOpen={handleSelectOpen}
          disabled={disabled}
          style={disabled ? { color: '#ccc', backgroundColor: 'hsl(0, 0%, 95%)' } : {}}
          onClose={handleSelectClose}
          renderValue={(selected) => selected}
        >
          <Box sx={{ height: 300, width: 500 }}>
            <DataGrid
              onSelectionModelChange={handleChange}
              getRowId={(row) => row?.[dynamicId]}
              rows={tableData || []}
              columns={columns}
              rowHeight={30}
              pageSize={pageSize}
              onPageSizeChange={(newPage) => setPageSize(newPage)}
              pagination
              components={{
                Toolbar: () => (
                  <GridToolbar
                    hiddenColumn={true}
                    hiddenExport={true}
                    hiddenContent={true}
                    hiddenRefresh={true}
                    hiddenFilter={true}
                    hiddenSize={true}
                  />
                ),
              }}
            />
          </Box>
        </Select>
      </FormControl>
    </>
  )
}

export default VendorCodeSelecboxGrid
